@use '~/theme/theme' as *;

.modal {
  min-width: 788px;
}

.modalContent {
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: spacing(5);
  overflow: hidden;
}

.transactionLabel {
  text-transform: uppercase;
}

.transactionSummary {
  padding: spacing(2);
  background-color: color(violet-100);

  @include border-radius(sm);

  margin: 0 spacing(3);
  margin-top: spacing(2);
}

.trendUp {
  color: color(green-600);
}

.trendDown {
  color: color(lobster-700);
}

.confirmSection {
  padding: spacing(3);
  display: flex;
  justify-content: flex-end;
}

.confirm {
  display: flex;
  align-items: center;
  gap: spacing(2);
}
